export default "__VITE_ASSET__6bb7a7b4__"